import {
  REGISTER_USER,
  REGISTER_USER_SUCCESS,
  REGISTER_USER_FAILURE,
  COMPLETE_REGISTRATION,
  COMPLETE_REGISTRATION_SUCCESS,
  COMPLETE_REGISTRATION_FAILURE,
  POLL_EMAIL_VERIFICATION,
  POLL_EMAIL_VERIFICATION_SUCCESS,
  POLL_EMAIL_VERIFICATION_FAILURE,
  STOP_POLL_EMAIL_VERIFICATION,
  RESEND_EMAIL_VERIFICATION,
  RESEND_EMAIL_VERIFICATION_SUCCESS,
  RESEND_EMAIL_VERIFICATION_FAILURE,
  RESEND_EMAIL_COOLDOWN_TICK,
  RESEND_EMAIL_COOLDOWN_EXPIRE,
  FETCH_PROFILE_FOR_COMPLETE_REGISTRATION,
  FETCH_PROFILE_FOR_COMPLETE_REGISTRATION_SUCCESS,
  FETCH_PROFILE_FOR_COMPLETE_REGISTRATION_FAILURE,
  INIT_COMPLETE_REGISTRATION,
  FETCH_ADDRESSES,
  FETCH_ADDRESSES_SUCCESS,
  FETCH_ADDRESSES_FAILURE,
  SELECT_ADDRESS,
  SELECT_ADDRESS_SUCCESS,
  SELECT_ADDRESS_FAILURE,
  RESET_AUTOCOMPLETE,
  FETCH_ADDRESSES_MIGRATE,
  FETCH_ADDRESSES_MIGRATE_SUCCESS,
  FETCH_ADDRESSES_MIGRATE_FAILURE,
  SELECT_ADDRESS_MIGRATE,
  SELECT_ADDRESS_MIGRATE_SUCCESS,
  SELECT_ADDRESS_MIGRATE_FAILURE,
  RESET_AUTOCOMPLETE_MIGRATE,
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_FAILURE,
  GET_FORGOT_PASSWORD_CODE,
  GET_FORGOT_PASSWORD_CODE_SUCCESS,
  GET_FORGOT_PASSWORD_CODE_FAILURE,
  CONFIRM_RESET_PASSWORD,
  CONFIRM_RESET_PASSWORD_SUCCESS,
  CONFIRM_RESET_PASSWORD_FAILURE,
  UPDATE_PROFILE,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAILURE,
  FETCH_PROFILE,
  FETCH_PROFILE_SUCCESS,
  FETCH_PROFILE_FAILURE,
  MIGRATE_PROFILE,
  MIGRATE_PROFILE_SUCCESS,
  MIGRATE_PROFILE_FAILURE,
  SAVE_USER_PROFILE,
  FETCH_GOV_ID_RESPONSE,
  FETCH_GOV_ID_RESPONSE_SUCCESS,
  FETCH_GOV_ID_RESPONSE_FAILURE,
  GET_GOV_ID_LINK,
  GET_GOV_ID_LINK_SUCCESS,
  GET_GOV_ID_LINK_FAILURE,
  GET_PREFILL_HINT,
  GET_PREFILL_HINT_SUCCESS,
  GET_PREFILL_HINT_FAILURE,
  SIGN_OUT,
  SIGN_OUT_SUCCESS,
  SIGN_OUT_FAILURE,
  VERIFY_EMAIL,
  VERIFY_EMAIL_SUCCESS,
  VERIFY_EMAIL_FAILURE,
} from '../constants';

export const registerUser = (registerUserForm, selectedAddressParsed, push) => ({
  type: REGISTER_USER,
  payload: {
    registerUserForm,
    selectedAddressParsed,
    push,
  },
});

export const registerUserSuccess = ({
  accessToken, refreshToken, identityToken, expiresIn, userDataParsed,
}) => ({
  type: REGISTER_USER_SUCCESS,
  payload: {
    accessToken,
    refreshToken,
    identityToken,
    expiresIn,
    userDataParsed,
  },
});

export const registerUserFailure = (statusCode, errorDetail, duplicatedEmail) => ({
  type: REGISTER_USER_FAILURE,
  payload: {
    statusCode,
    errorDetail,
    duplicatedEmail,
  },
});

export const completeRegistration = (completeRegistrationForm, selectedAddressParsed, push) => ({
  type: COMPLETE_REGISTRATION,
  payload: {
    completeRegistrationForm,
    selectedAddressParsed,
    push,
  },
});

export const completeRegistrationSuccess = ({ verificationLink }) => ({
  type: COMPLETE_REGISTRATION_SUCCESS,
  payload: { verificationLink },
});

export const completeRegistrationFailure = (statusCode, errorDetail, duplicatedEmail) => ({
  type: COMPLETE_REGISTRATION_FAILURE,
  payload: {
    statusCode,
    errorDetail,
    duplicatedEmail,
  },
});

export const pollEmailVerification = (push) => ({
  type: POLL_EMAIL_VERIFICATION,
  payload: { push },
});

export const pollEmailVerificationSuccess = ({ emailVerified }) => ({
  type: POLL_EMAIL_VERIFICATION_SUCCESS,
  payload: { emailVerified },
});

export const pollEmailVerificationFailure = ({ statusCode, errorDetail }) => ({
  type: POLL_EMAIL_VERIFICATION_FAILURE,
  payload: {
    statusCode,
    errorDetail, 
  },
});

export const stopPollEmailVerification = () => ({
  type: STOP_POLL_EMAIL_VERIFICATION,
  payload: {},
});

export const resendEmailVerification = (push) => ({
  type: RESEND_EMAIL_VERIFICATION,
  payload: { push },
});

export const resendEmailVerificationSuccess = ({ message }) => ({
  type: RESEND_EMAIL_VERIFICATION_SUCCESS,
  payload: { message },
});

export const resendEmailVerificationFailure = ({ message, statusCode }) => ({
  type: RESEND_EMAIL_VERIFICATION_FAILURE,
  payload: { message, statusCode },
});

export const resendEmailCooldownTick = ({ secondsRemaining }) => ({
  type: RESEND_EMAIL_COOLDOWN_TICK,
  payload: { secondsRemaining },
});

export const resendEmailCooldownExpire = () => ({
  type: RESEND_EMAIL_COOLDOWN_EXPIRE,
  payload: {},
});

export const fetchProfileForCompleteRegistration = () => ({
  type: FETCH_PROFILE_FOR_COMPLETE_REGISTRATION,
  payload: {},
});

export const fetchProfileForCompleteRegistrationSuccess = ({ profileFields }) => ({
  type: FETCH_PROFILE_FOR_COMPLETE_REGISTRATION_SUCCESS,
  payload: { profileFields },
});

export const fetchProfileForCompleteRegistrationFailure = ({ errorDetail }) => ({
  type: FETCH_PROFILE_FOR_COMPLETE_REGISTRATION_FAILURE,
  payload: { errorDetail },
});

export const initCompleteRegistration = (push) => ({
  type: INIT_COMPLETE_REGISTRATION,
  payload: { push },
});

export const verifyEmail = () => ({
  type: VERIFY_EMAIL,
  payload: {},
});

export const verifyEmailSuccess = () => ({
  type: VERIFY_EMAIL_SUCCESS,
  payload: {},
});

export const verifyEmailFailure = (statusCode, errorDetail) => {
  return {
    type: VERIFY_EMAIL_FAILURE,
    payload: {
      statusCode,
      errorDetail,
    },
  };
};

export const fetchAddresses = (input) => ({
  type: FETCH_ADDRESSES,
  payload: { input },
});

export const fetchAddressesSuccess = ({ response }) => ({
  type: FETCH_ADDRESSES_SUCCESS,
  payload: { response },
});

export const fetchAddressesFailure = ({ statusCode, errorDetail }) => ({
  type: FETCH_ADDRESSES_FAILURE,
  payload: {
    statusCode,
    errorDetail,
  },
});

export const selectAddress = ({ address }) => ({
  type: SELECT_ADDRESS,
  payload: { address },
});

export const resetAutocomplete = () => ({
  type: RESET_AUTOCOMPLETE,
  payload: {},
});

export const selectAddressSuccess = ({ parsedAddress, address }) => ({
  type: SELECT_ADDRESS_SUCCESS,
  payload: {
    parsedAddress,
    address,
  },
});

export const selectAddressFailure = ({ error }) => ({
  type: SELECT_ADDRESS_FAILURE,
  payload: { error },
});

export const fetchAddressesMigrate = (input) => ({
  type: FETCH_ADDRESSES_MIGRATE,
  payload: { input },
});

export const fetchAddressesMigrateSuccess = ({ response }) => ({
  type: FETCH_ADDRESSES_MIGRATE_SUCCESS,
  payload: { response },
});

export const fetchAddressesMigrateFailure = ({ statusCode, errorDetail }) => ({
  type: FETCH_ADDRESSES_MIGRATE_FAILURE,
  payload: {
    statusCode,
    errorDetail,
  },
});

export const selectAddressMigrate = ({ address }) => ({
  type: SELECT_ADDRESS_MIGRATE,
  payload: { address },
});

export const resetAutocompleteMigrate = () => ({
  type: RESET_AUTOCOMPLETE_MIGRATE,
  payload: {},
});

export const selectAddressMigrateSuccess = ({ parsedAddress, address }) => ({
  type: SELECT_ADDRESS_MIGRATE_SUCCESS,
  payload: {
    parsedAddress,
    address,
  },
});

export const selectAddressMigrateFailure = ({ error }) => ({
  type: SELECT_ADDRESS_MIGRATE_FAILURE,
  payload: { error },
});

export const loginUser = (loginUserForm, push) => ({
  type: LOGIN_USER,
  payload: {
    loginUserForm,
    push,
  },
});

export const loginUserSuccess = ({
  accessToken, refreshToken, identityToken, expiresIn,
}) => ({
  type: LOGIN_USER_SUCCESS,
  payload: {
    accessToken,
    refreshToken,
    identityToken,
    expiresIn,
  },
});

export const loginUserFailure = ({ statusCode, errorDetail }) => ({
  type: LOGIN_USER_FAILURE,
  payload: {
    statusCode,
    errorDetail,
  },
});

export const getForgotPasswordCode = (forgotPasswordForm) => ({
  type: GET_FORGOT_PASSWORD_CODE,
  payload: { forgotPasswordForm },
});

export const getForgotPasswordCodeSuccess = () => ({
  type: GET_FORGOT_PASSWORD_CODE_SUCCESS,
  payload: {},
});

export const getForgotPasswordCodeFailure = ({ statusCode, errorDetail }) => ({
  type: GET_FORGOT_PASSWORD_CODE_FAILURE,
  payload: {
    statusCode,
    errorDetail,
  },
});

export const confirmResetPassword = (confirmResetPasswordForm) => ({
  type: CONFIRM_RESET_PASSWORD,
  payload: { confirmResetPasswordForm },
});

export const confirmResetPasswordSuccess = () => ({
  type: CONFIRM_RESET_PASSWORD_SUCCESS,
  payload: {},
});

export const confirmResetPasswordFailure = ({ statusCode, errorDetail }) => ({
  type: CONFIRM_RESET_PASSWORD_FAILURE,
  payload: {
    statusCode,
    errorDetail,
  },
});

export const updateProfile = (updateProfileForm, push) => ({
  type: UPDATE_PROFILE,
  payload: {
    updateProfileForm,
    push,
  },
});

export const updateProfileSuccess = () => ({
  type: UPDATE_PROFILE_SUCCESS,
  payload: {},
});

export const updateProfileFailure = (statusCode, errorDetail) => ({
  type: UPDATE_PROFILE_FAILURE,
  payload: {
    statusCode,
    errorDetail,
  },
});

export const fetchProfile = (isUpdateProfile) => ({
  type: FETCH_PROFILE,
  payload: { isUpdateProfile },
});

export const fetchProfileSuccess = (profile, isUpdateProfile = false) => ({
  type: FETCH_PROFILE_SUCCESS,
  payload: {
    profile,
    isUpdateProfile,
  },
});

export const fetchProfileFailure = (error) => ({
  type: FETCH_PROFILE_FAILURE,
  payload: { error },
});

export const migrateProfile = (migrateProfileForm, selectedAddressParsed, push) => ({
  type: MIGRATE_PROFILE,
  payload: {
    migrateProfileForm,
    selectedAddressParsed,
    push,
  },
});

export const migrateProfileSuccess = ({
  accessToken, refreshToken, identityToken, expiresIn, userDataParsed,
}) => ({
  type: MIGRATE_PROFILE_SUCCESS,
  payload: {
    accessToken,
    refreshToken,
    identityToken,
    expiresIn,
    userDataParsed,
  },
});

export const migrateProfileFailure = (statusCode, errorDetail) => ({
  type: MIGRATE_PROFILE_FAILURE,
  payload: {
    statusCode,
    errorDetail,
  },
});

export const saveUserProfile = ({ userData }) => ({
  type: SAVE_USER_PROFILE,
  payload: { userData },
});

export const fetchGovIdResponse = (code, push) => ({
  type: FETCH_GOV_ID_RESPONSE,
  payload: {
    code,
    push,
  },
});

export const getGovIdLink = (govIdType, linkType) => ({
  type: GET_GOV_ID_LINK,
  payload: {
    govIdType,
    linkType,
  },
});

export const getGovIdLinkSuccess = ({ link }) => ({
  type: GET_GOV_ID_LINK_SUCCESS,
  payload: { link },
});

export const getGovIdLinkFailure = (errorDetail) => ({
  type: GET_GOV_ID_LINK_FAILURE,
  payload: { errorDetail },
});

export const getPrefillHint = (authorizeUrlParams) => ({
  type: GET_PREFILL_HINT,
  payload: authorizeUrlParams,
});

export const getPrefillHintSuccess = ({ redirectUrl }) => ({
  type: GET_PREFILL_HINT_SUCCESS,
  payload: { redirectUrl },
});

export const getPrefillHintFailure = (errorDetail) => ({
  type: GET_PREFILL_HINT_FAILURE,
  payload: { errorDetail },
});

export const fetchGovIdResponseSuccess = ({ response }) => ({
  type: FETCH_GOV_ID_RESPONSE_SUCCESS,
  payload: { response },
});

export const fetchGovIdResponseFailure = (statusCode, errorDetail) => ({
  type: FETCH_GOV_ID_RESPONSE_FAILURE,
  payload: {
    statusCode,
    errorDetail,
  },
});

export const signOut = (push) => ({
  type: SIGN_OUT,
  payload: { push },
});

export const signOutSuccess = () => ({
  type: SIGN_OUT_SUCCESS,
  payload: {},
});

export const signOutFailure = ({ statusCode, errorDetail }) => ({
  type: SIGN_OUT_FAILURE,
  payload: {
    statusCode,
    errorDetail,
  },
});
